import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions } from '@angular/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

import { ICita, IAseguradora  } from '../model/trjireh-model';

@Injectable()
export class CitaApiService {

  // aseguradoras: IAseguradora[] = [];

  citaURL: string = config.API_DATA_URL + '/cita';

  constructor(public http: HttpClient) {}

  // public getAseguradoras(): Observable<any> {
  //   const headers = this.getHeaders();

  //   return this.http.get(this.aseguradoraURL, { headers })
  //   .map( (aseguradoras: IAseguradora[]) => {
  //       this.aseguradoras = aseguradoras;
  //       return this.aseguradoras;
  //     })
  //   .catch(this.handleError)
  // }

  public getCitasSucursal(sucursal: number) {
    const headers = this.getHeaders();

    return this.http.get(this.citaURL + '/sucursal/' + sucursal, { headers })
    .map( (citas: any) => {
        // console.log(citas);
        return citas;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
    });
  }

  public AgendarCita(cita: ICita) {
    const headers = this.getHeaders();
    const param = JSON.stringify(cita);

    return this.http.post(this.citaURL + '/agendar', param, { headers })
      .map( (resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
          return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/cita-api.service.ts